import React from 'react';
// import { Navigate } from 'react-router-dom';
// import { useAuth } from './AuthContext';
// import {checkRoutesAuth} from "./menu.js"
import ErrorPage from './ErrorPage'
import { MasterContext } from "../services/MasterContext";
import Loader from "../images/impulse/gif.gif"
const ProtectedRoute = ({ children, requiredRole, routeAuth }) => {
//   const { user } = useAuth();
let {userRole} = React.useContext(MasterContext);

// function checkRoutesAuth(context) {
//   //console.log(context)
//     const permission = userRole?.data?.find(permission => permission.applicationcontext === context);
//     //console.log(permission)
//     if (permission) {
//       if(permission.accessPersmission === 1){
//         return permission.accessPersmission === 1;
//       }
//     }
// }

function checkRoutesAuth(context) {
  // //console.log(context);
  const permissions = userRole?.data?.filter(permission => permission.applicationcontext === context);
  //console.log(permissions);
  
  if (permissions && permissions.length > 0) {
      for (const permission of permissions) {
          if (permission.accessPersmission === 1) {
              return true;
          }
      }
  }
  
  return false;
}

if(userRole?.data){
  if (checkRoutesAuth(routeAuth)) {
    return children;
  }else{
    return (
        <div style={{ padding: '20px', display: 'flex', justifyContent: 'center', marginTop: '100px' }}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', border: '2px dashed gray', width: '600px', height: '200px', borderRadius: '20px' }}>
                <div style={{ textAlign:'center' }}>
                    <h4 style={{ fontSize: '22px' }}>You do not have permission to view this page.</h4>
                    <p style={{fontSize: '16px', margin: '0px' }}>Please contact the administrator for more information.</p>
                </div>
            </div>
        </div>
    )
  }
}else{
  return (
          <>
          {userRole?.error==="ERR_NETWORK"?<ErrorPage errorType={userRole?.error}/>:
          userRole?.error==="ServerError"?<ErrorPage errorType={userRole?.error}/>:
           <div style={{ padding: '20px', display: 'flex', justifyContent: 'center'}}>
           <div style={{overflow: 'hidden', position: 'relative', height: '500px', width:"500px" }}>
               <img src={Loader} style={{ height: '100%', width:'100%', objectPosition: 'center', objectFit: 'cover'}}/>
           </div>
           </div>
          }
          </>
        )
}
  
};

export default ProtectedRoute;